import { useState, useCallback } from 'react';
import EntrepriseService from '../services/entrepriseService';
import RoleHelper from '../utils/roleHelper';

export const useCredits = (currentUser, adminImpersonatingRecruteurId, history) => {
    const [creditsInfo, setCreditsInfo] = useState({ available: null, maximum: null });
    const [isLoadingCredits, setIsLoadingCredits] = useState(false);
    const entrepriseService = new EntrepriseService();

    const fetchCredits = useCallback(async () => {
        if (RoleHelper.isEntreprise(currentUser) || (adminImpersonatingRecruteurId && RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname))) {
            setIsLoadingCredits(true);
            try {
                // If it's an impersonal admin, we first retrieve the company ID
                if (adminImpersonatingRecruteurId && RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname)) {
                    const entrepriseId = await entrepriseService.getEntreprisesOfRecruteur(adminImpersonatingRecruteurId);
                    const credits = await entrepriseService.getCreditsInfo(adminImpersonatingRecruteurId);
                    setCreditsInfo(credits);
                    return credits;
                } else {
                    // For a normal company, we use the currentUser ID
                    const credits = await entrepriseService.getCreditsInfo(currentUser.user.id);
                    setCreditsInfo(credits);
                    return credits;
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des crédits:', error);
                return null;
            } finally {
                setIsLoadingCredits(false);
            }
        }
        return null;
    }, [currentUser, adminImpersonatingRecruteurId, history.location.pathname]);

    const executeActionWithCreditCheck = useCallback(async (actionFunction) => {
        try {
            const result = await actionFunction();
            
            // If the action has used up a credit, recharge the credits
            if (result && result.creditConsumed) {
                // If new credits are provided in the answer, use them.
                if (result.newCreditsInfo) {
                    setCreditsInfo(result.newCreditsInfo);
                } else {
                    // Otherwise, refetch from the server
                    await fetchCredits();
                }
            }
            
            return result;
        } catch (error) {
            console.error('Erreur lors de l\'exécution de l\'action:', error);
            return { success: false, creditConsumed: false, message: 'Erreur inattendue' };
        }
    }, [fetchCredits]);

    return {
        creditsInfo,
        isLoadingCredits,
        fetchCredits,
        executeActionWithCreditCheck,
        refreshCredits: fetchCredits
    };
};
